import AsyncStorage from '@react-native-async-storage/async-storage';
import { createTransform } from 'redux-persist';

// Transform to remove heavy data from promiseData to prevent QuotaExceededError on web
const promiseDataTransform = createTransform(
	(inboundState: any, key) => {
		if (key === 'promiseData' && inboundState?.data?.userData) {
			const { userData } = inboundState.data;
			return {
				...inboundState,
				data: {
					...inboundState.data,
					userData: {
						...userData,
						// Strip out potentially massive arrays to save localStorage space
						posts: { liked_posts: [] },
						favourites: { projects: [], data: [], news: [] },
						calendar: {},
						// If context weights get massive, we can strip them too, but keeping them for now
					}
				}
			};
		}
		return inboundState;
	},
	(outboundState, key) => outboundState,
	{ whitelist: ['promiseData'] }
);

// Redux Persist configuration
export const persistConfig = {
	key: 'root',
	storage: AsyncStorage,
	transforms: [promiseDataTransform],
	blacklist: [
		'modal',
		'actionMaker',
		'lastAction',
		'uploadPreview',
		'calendar',
		'notifications',
		'toolbar',
		'modals',
		'report',
		'errors',
		'UI',
		'tutorials',
		'widgets',
		'achievements',
		'store',
		'userHierarchy',
		'project',
	],
};
